<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('municipalities.details.name') }}</label></td>
      <td>{{ details.name }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.description') }}</label></td>
      <td>{{ details.description }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('municipalities.details.resident_pricing') }}</label></td>
      <td>{{ details.resident_pricing | yesNo }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updatedBy') }}</label></td>
      <td>{{ details.modified_by }}</td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'municipality-details',
  components: {},
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
